import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { uxuiImprovementPageMeta, uxuiImprovementSchema } from 'components/common/schema'
import Template from 'components/services/uxui-improvement'

const UXUIImprovement: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...uxuiImprovementPageMeta} />
      <JsonLd data={uxuiImprovementSchema} />
      <Template />
    </>
  )
}

export default UXUIImprovement
